<!--
Copyright 2024 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license. See LICENSE.md in the
project root for license information.
-->

<div class="frame">
  <div id="printable-area">
    <div class="header-div">
      <h2>MSEL Playbook</h2>
      <div class="right-buttons no-print">
        <button
          aria-label="Print MSEL Playbook"
          mat-icon-button
          style="outline: none;"
          title="Print MSEL Playbook"
          (click)="printpage()"
          >
          <mat-icon aria-hidden="false" class="mdi-24px" fontIcon="mdi-printer"></mat-icon>
        </button>
      </div>
    </div>
    @if (msel) {
      <div class="table-container">
        @for (scenarioEvent of getPagedScenarioEvents(); track scenarioEvent.id; let i = $index) {
          <table id="eventDetails" class="page-break">
            <thead>
              <tr>
                <th style="width: 100px;">Title</th>
                <th>{{ getTitleForScenarioEvent(scenarioEvent.id) }}</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style="font-weight:bold;">Move</td>
                <td>{{ getMoveNumber(scenarioEvent.id) }}</td>
              </tr>
              @for (df of allDataFields; track df.id) {
                @if (getScenarioEventValue(scenarioEvent, df.name) && df.name != 'Title') {
                  <tr>
                    <td style="font-weight:bold;">{{ df.name }}</td>
                    <td [innerHTML]="getScenarioEventValue(scenarioEvent, df.name)"></td>
                  </tr>
                }
              }
            </tbody>
          </table>
        }
        <mat-paginator [length]="sortedScenarioEvents.length" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions"
          (page)="changePage($event)" class="no-print">
        </mat-paginator>
      </div>
    }
  </div>
</div>
